import { Directive, ElementRef, AfterViewInit, HostListener, Renderer2 } from '@angular/core';

@Directive({
    selector: '[isEllipsisActive]',
    standalone: false
})
export class IsEllipsisActiveDirective implements AfterViewInit {

  domElement: any;
  constructor(
    private renderer: Renderer2,
    private elementRef: ElementRef
  ) {
    this.domElement = this.elementRef.nativeElement; // to get DOM element and store it in global variable
  }

  // to check and add title attribute on the element at the time when application renders first time. 
  ngAfterViewInit(): void {
    // to see effect try removing below two lines and check if the title is added at the first time rendering.   
    this.renderer.setProperty(this.domElement, 'scrollTop', 1);
    this.isTitleAttribute();
  }

  @HostListener("window:resize")
  isTitleAttribute() {
    // to add or remove title attribute on the element when it is changing width.
    (this.domElement.offsetWidth < this.domElement.scrollWidth) ?
      this.renderer.setAttribute(this.domElement, 'data-title', this.domElement.textContent) :
      this.renderer.removeAttribute(this.domElement, 'data-title');
  }
}
